import React, {useState, useEffect} from 'react';
import { Paper, Box, Typography, 
    Button, TextField, FormControl, Select, MenuItem, 
    InputLabel, Checkbox, FormHelperText,
    FormLabel,RadioGroup,FormControlLabel,Radio, Tooltip} from '@mui/material';

import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate } from 'react-router-dom';
import Loader from "../circularProgress";



export default function PersonalDetailsForm({userData}) {

    const [personalData, setPersonalData] = useState({
        positionAppliedFor: null,
        name: '',
        gender: '',
        dob: '',
        age: '',
        maritalStatus: '',
        bloodGroup: '',
        height: '',
        weight: '',
        contact_address: '',
        permanent_address: '',

        // Educational Qualification
        qualification: '',
        institution: '',
        passingYear: '',

        yearsOfExperience: '',
        company: '',
        joiningDate: '',
        employmentStatus: '',
        lastSalary: '',

        expectedSalary: '',
        suretyAgreement: null,
        joiningDays: '',
        is_draft: true
        
    });

    const [formErrors, setFormErrors] = useState({
        positionAppliedFor: null,
        name: '',
        gender: '',
        dob: '',
        age: '',
        maritalStatus: '',
        bloodGroup: '',
        height: '',
        weight: '',
        contact_address: '',
        permanent_address: '',

        qualification: '',
        institution: '',
        passingYear: '',

        yearsOfExperience: '',
        company: '',
        joiningDate: '',
        employmentStatus: '',
        lastSalary: '',

        expectedSalary: '',
        suretyAgreement: null,
        joiningDays: ''


    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [isSameAddress, setIsSameAddress] = useState(false);
    const [positionNames, setPositionNames] = useState([]); // PDS - 31561
    const [isLoading, setIsLoading] = useState(false); // PDS - 31561


    const selectedPosition = positionNames.find(pos => pos.position_id === personalData.positionAppliedFor); // PDS - 31561

    const selectedDescription = selectedPosition?.short_description || ''; // PDS - 31561
   
    // console.log("Position Names: ", positionNames);
    
    const navigate = useNavigate();

    useEffect(() => {
        if(userData) {
            setPersonalData(prevData => ({...prevData, name: userData.name}))
        }
    },[userData])

    
    
    useEffect(() => {
    // Function to fetch data
    const fetchPositions = async () => {
      try {
        const response = await axios.post(`${API_URL}/positions`);
        setPositionNames(response.data);
      } catch (error) {
        console.error('Error fetching positions:', error);
      } 
    };

    fetchPositions(); // Call the function
  }, []);




    function handleCheckedBox(evt) {
        const isChecked = evt.target.checked;
        setIsSameAddress(isChecked);

        if(isChecked) {
            setPersonalData(currState => ({...currState, 
                permanent_address: currState.contact_address }))
        } else {
            setPersonalData(currState => ({...currState, permanent_address: ""}))
        }


    }

    

    function validateForm() {

        const errors = {};
        if (!personalData?.positionAppliedFor) errors.positionAppliedFor = "Position is required"
        if (!personalData.name) errors.name = "Name is required";
        if (!personalData.gender) errors.gender = "Gender is required";
        if (!personalData.dob) errors.dob = "Date of Birth is required";
        if (!personalData.age) errors.age = "Age is required";
        if (!personalData.maritalStatus) errors.maritalStatus = "Marital Status is required";
        if (!personalData.bloodGroup) errors.bloodGroup = "Blood Group is required";
        if (!personalData.height) errors.height = "Height is required";
        if (!personalData.weight) errors.weight = "Weight is required";
        if (!personalData.contact_address) errors.contact_address = "Contact Address is required";
        if (!personalData.permanent_address) errors.permanent_address = "Permanent Address is required";

        if (!personalData.qualification) errors.qualification = "Qualification is required";
        if (!personalData.institution) errors.institution = "Institution is required";
        if (!personalData.passingYear) errors.passingYear = "Passing year is required";

         // Work Experience validation
        if (!personalData.yearsOfExperience) errors.yearsOfExperience = "Years of experience is required";
        if (!personalData.company) errors.company = "Company name is required";
        if (!personalData.joiningDate) errors.joiningDate = "Joining date is required";
        if (!personalData.employmentStatus) errors.employmentStatus = "Employment status is required";
        if (!personalData.lastSalary) errors.lastSalary = "Last salary is required";
        
        // Salary Expectations validation
        if (!personalData.expectedSalary) errors.expectedSalary = "Expected salary is required";
        if (personalData.suretyAgreement === null || personalData.suretyAgreement === undefined) {
            errors.suretyAgreement = "Surety agreement response is required";
        }
        if (!personalData.joiningDays) errors.joiningDays = "Joining days is required";


        setFormErrors(errors);
        
        return Object.keys(errors).length === 0;
    }

    function handleErrors(field, value) {
        let errorMessage = '';
    
        // Convert non-string values to strings before calling trim()
        if (typeof value !== 'string') {
            value = String(value);
        }
    
        if (value === null || (typeof value === 'string' && !value.trim())) {
            errorMessage = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
        }
    
        setFormErrors((prevErrors) => ({ ...prevErrors, [field]: errorMessage }));
    }
    
    function handlePersonalDataChange(field, value) {

        if (field === 'dob') {
            const birthDate = new Date(value);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const month = today.getMonth() - birthDate.getMonth();

            if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            setPersonalData((prevData) => (
                {...prevData, dob: value, age: age > 0 ? age : ''}));
        } else {
            setPersonalData((prevData) => ({
            ...prevData,
            [field]: value
            }));
        }
    }



// const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//         setIsSubmitting(true);
//         try {
//             const response = await axios.post('http://localhost:5000/personalDetails', personalData, {
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (response.data.message) {
//                 alert(response.data.message);
//             } else {
//                 alert('No message from server');
//             }
//         } catch (error) {
//             alert(error.response?.data?.error || 'Something went wrong!');
//         }
//     }
// };

//   Auto-save timer
//   useEffect(() => {

//     const storedUserData = localStorage.getItem("personalData");

//     if (!storedUserData) return; // If no data, exit

//     const userData = JSON.parse(storedUserData);
//     const id = userData.id; // Extract ID

//     if (!id) return;
//     let saveTimer;
    
//     const autoSaveDraft = async () => {
//         try {
//             await axios.post(`http://localhost:5000/personalDetails/${id}`, 
//                 { ...personalData, is_draft: true },
//                 { headers: { 'Content-Type': 'application/json' }}
//             );
//             console.log('Draft auto-saved');
//         } catch (error) {
//             console.error('Error auto-saving draft:', error);
//         }
//     };

//     // Save draft every 30 seconds if there are changes
//     if (Object.keys(personalData).length > 0) {
//         saveTimer = setInterval(autoSaveDraft, 20000);
//     }

//     return () => {
//         if (saveTimer) clearInterval(saveTimer);
//     };
// }, [personalData]);

    


// useEffect(() => {
//     const storedUserData = localStorage.getItem("personalData");

//     if (!storedUserData) return; // If no data, exit

//     const userData = JSON.parse(storedUserData);
//     const id = userData.id; // Extract ID

//     if (!id) return;
       
//         const fetchDraft = async () => {
//             try {
//                 const response = await axios.get(`getPersonalDetails/${id}`);

//                 if(response.data) {
//                     setPersonalData(response.data);
//                     console.log(response.data)
//                 }
//             } catch (error) {
//                 console.error("Error Fetching Draft Data", error)
//             }
//         };
//         fetchDraft();
//     }, []);

    // useEffect(() => {

    //     const storedUserData = localStorage.getItem("personalData");

    //     if (!storedUserData) return; // If no data, exit
    
    //     const userData = JSON.parse(storedUserData);
    //     const id = userData.id; // Extract ID
    
    //     if (!id) return;
    //     const saveDraft = async () => {
    //             await axios.post(`http://localhost:5000/personalDetails/${id}`, { ...personalData, is_draft: true },
    //             {
    //                 headers: { 'Content-Type': 'application/json' },
    //                 timeout: 5000, // 5 second timeout
    //                 // Ensure the request completes even if the page is unloading
    //                 signal: new AbortController().signal
    //             }
    //         );
    //     };
    
    //     window.addEventListener("beforeunload", saveDraft);
        
    //     return () => {
    //         window.removeEventListener("beforeunload", saveDraft);
    //     };
    // }, [personalData]);

// const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//         setIsSubmitting(true);
//         try {
//             const response = await axios.post(`http://localhost:5000/personalDetails/${userData.id}`, personalData, {
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (response.data.message) {
//                 alert(response.data.message);
//             } else {
//                 alert('No message from server');
//             }
//         } catch (error) {
//             alert(error.response?.data?.error || 'Something went wrong!');
//         }
//     }
// };
const API_URL = process.env.REACT_APP_BASE_URL;
const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    if (validateForm()) {
        setIsSubmitting(true);
        try {
            const response = await axios.post(`${API_URL}/personalDetails/${userData.id}`, {...personalData,is_draft: false}, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.message) {
                alert(response.data.message);
                navigate("/login");
            } else {
                alert('Oops! Sorry Try Again');
            }
        } catch (error) {
            alert(error.response?.data?.error || 'Something went wrong!');
        } finally {
            setIsLoading(false);
        }
    } else {
        setIsLoading(false);
    }
};



    return (
        <Paper elevation={3} sx={{ maxWidth: '1000px', mx: 'auto', p: 4, position: "relative"}}>
            
            <div style={{position: "relative"}}>
            <form onSubmit= {handleSubmit}>
                <Typography variant="h3" component="h1" align="center" gutterBottom>
                    Personal Data Sheet
                </Typography>
            
            
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                mb: 2,
                '@media (max-width:600px)': {
                display: 'grid',
                gridTemplateColumns: '1fr',
                textAlign: 'center'
            },
            }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    Welcome {userData.name.charAt(0).toUpperCase() + userData.name.slice(1)} !
                </Typography>

                <Typography variant="h6" component="h2" gutterBottom>
                    Mobile:{userData.mobile} 
                </Typography>
            </Box>

            {/* BASIC PERSONAL INFORMATION */}

            <Box sx={{
                 display: 'grid',
                 gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'},
                 gap: 3,
                 mb: 4 
             }}>

                  {/* Full-width FormControl for Position Applied For */}
                <FormControl
                    fullWidth
                    error={!!formErrors.positionAppliedFor}
                    disabled={isSubmitting}
                    sx={{ gridColumn: '1 / -1' }} // span full grid width
                >
                    <InputLabel>Position Applied For</InputLabel>
                   
                     {/* <MenuItem value="Frontend Developer (ReactJs)">Frontend Developer (ReactJs)</MenuItem>
                    <MenuItem value="Backend Developer (ReactJs/NodeJs/MS SQL/PostgreSQL)">
                    Backend Developer (ReactJs/NodeJs/MS SQL/PostgreSQL)
                    </MenuItem>
                    <MenuItem value="Full stack Developer (ReactJs/NodeJs/MS SQL/PostgreSQL)">
                    Full stack Developer (ReactJs/NodeJs/MS SQL/PostgreSQL)
                    </MenuItem>
                    <MenuItem value="Junior Scientific Assistant">Junior Scientific Assistant</MenuItem>
                    <MenuItem value="Accounts Executive">Accounts Executive</MenuItem>
                    <MenuItem value="Process Engineer">Process Engineer</MenuItem>
                    <MenuItem value="Quality Engineer">Quality Engineer</MenuItem>
                    <MenuItem value="Administrative Assistant">Administrative Assistant</MenuItem>
                    <MenuItem value="Chemist">Chemist</MenuItem> */}

                <Select
                    label="Position Applied For"
                    value={personalData.positionAppliedFor} // this is the selected position_id
                    onChange={(e) =>
                        handlePersonalDataChange('positionAppliedFor', parseInt(e.target.value))
                    }
                    onBlur={(e) =>
                        handleErrors('positionAppliedFor', parseInt(e.target.value))
                    }
                    >
                    {positionNames.map((pos) => (
                        <MenuItem key={pos.position_id} value={pos.position_id}>
                        {pos.position_name}
                        </MenuItem>
                    ))}
                </Select>
                    
                    <FormHelperText>{formErrors.positionAppliedFor}</FormHelperText>
                     {selectedDescription && (
                        <FormHelperText
                             sx={{
                                fontSize: '0.95rem', 
                                color: 'primary.main',
                                mt: 1
                                
                                }}
                        
                        >{selectedDescription}</FormHelperText>
                     )}
                </FormControl>

                <TextField
                    fullWidth
                    label="Name"
                    placeholder="Full Name"
                    value = {userData.name}
                    error = {!! formErrors.name}
                    // onBlur={evt => handleErrors('name', evt.target.value)}
                    helperText={formErrors.name}
                    // onChange={(e) => handlePersonalDataChange('name', e.target.value)}
                    variant="outlined"
                    disabled={true}
                   
                />

                <FormControl fullWidth error={!!formErrors.gender} disabled={isSubmitting}>
                    <InputLabel>Gender</InputLabel>
                    <Select label="Gender" 
                            defaultValue="" 
                            value={personalData.gender}
                            onChange={e => handlePersonalDataChange('gender', e.target.value)}
                            onBlur={evt => handleErrors('gender', evt.target.value)}
                            
                            >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="Transgenders">Transgenders</MenuItem>
                    </Select>
                    <FormHelperText>{formErrors.gender}</FormHelperText>
                </FormControl>

                

                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Date of Birth"
                    value={personalData.dob ? dayjs(personalData.dob) : null}
                    onChange={(newValue) => handlePersonalDataChange("dob", newValue ? newValue.format("YYYY-MM-DD") : "")}
                    format="YYYY-MM-DD" // Ensures consistency with input value
                    slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: "outlined",
                        error: !!formErrors.dob,
                        helperText: formErrors.dob,
                        onBlur: (evt) => handleErrors("dob", evt.target.value),
                        disabled: isSubmitting,
                        sx: {
                        "& .MuiInputLabel-root": { transform: "translate(14px, -13px) scale(0.75)" },
                        },
                    },
                    }}
                />
                </LocalizationProvider> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Date of Birth"
                        value={personalData.dob ? dayjs(personalData.dob, "YYYY-MM-DD") : null}
                        onChange={(newValue) => {
                            if (newValue) {
                                // Convert from DD-MM-YYYY (user input) to YYYY-MM-DD (database format)
                                const formattedDate = newValue.format("YYYY-MM-DD");
                                handlePersonalDataChange("dob", formattedDate);
                            } else {
                                handlePersonalDataChange("dob", "");
                            }
                        }}
                        format="DD-MM-YYYY" // Show as DD-MM-YYYY to the user
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                variant: "outlined",
                                error: !!formErrors.dob,
                                helperText: formErrors.dob,
                                onBlur: (evt) => handleErrors("dob", evt.target.value),
                                disabled: isSubmitting,
                                sx: {
                                    "& .MuiInputLabel-root": { transform: "translate(14px, -13px) scale(0.75)" },
                                },
                            },
                        }}
                    />

                </LocalizationProvider>


                <TextField
                    fullWidth
                    label="Age"
                    type="number"
                    variant='outlined'
                    value={personalData.age}
                    onChange={(e) => handlePersonalDataChange('age', parseInt(e.target.value))}
                    error={!!formErrors.age}
                    onBlur={evt => handleErrors('age', evt.target.value)}
                    helperText={formErrors.age}
                    disabled={isSubmitting}
                />

                <FormControl fullWidth error={!!formErrors.maritalStatus} disabled={isSubmitting}>
                    <InputLabel>Marital Status</InputLabel>
                    <Select label="Marital Status" 
                        value={personalData.maritalStatus} 
                        onChange={e => handlePersonalDataChange('maritalStatus', e.target.value)}
                        defaultValue=""
                        onBlur={evt => handleErrors('maritalStatus', evt.target.value)}
                       
                        >
                        <MenuItem value="single">Single</MenuItem>
                        <MenuItem value="married">Married</MenuItem>
                        <MenuItem value="divorced">Divorced</MenuItem>
                        <MenuItem value="widowed">Widowed</MenuItem>
                    </Select>
                    <FormHelperText>{formErrors.maritalStatus}</FormHelperText>
                </FormControl>

                <TextField
                    fullWidth
                    label="Blood Group"
                    variant="outlined"
                    value={personalData.bloodGroup}
                    onChange={(e) => handlePersonalDataChange('bloodGroup', e.target.value)}
                    error={!!formErrors.bloodGroup}
                    onBlur={evt => handleErrors('bloodGroup', evt.target.value)}
                    helperText={formErrors.bloodGroup}
                    disabled={isSubmitting}
                />

                <TextField
                    fullWidth
                    type="number"
                    label="Height (cm)"
                    variant="outlined"
                    value={personalData.height}
                    onChange={(e) => handlePersonalDataChange('height', parseInt(e.target.value))}
                    error={!!formErrors.height}
                    onBlur={evt => handleErrors('height', evt.target.value)}
                    helperText={formErrors.height}
                    disabled={isSubmitting}
                />

                <TextField
                    fullWidth
                    type="number"
                    label="Weight (kg)"
                    variant="outlined"
                    value={personalData.weight}
                    onChange={(e) => handlePersonalDataChange('weight', parseInt(e.target.value))}
                    error={!!formErrors.weight}
                    onBlur={evt => handleErrors('weight', evt.target.value)}
                    helperText={formErrors.weight}
                    disabled={isSubmitting}

                    />

                <Box position="relative" display="flex" flexDirection="" gap={2}>
                <TextField
                    fullWidth
                    label="Contact Address"
                    variant="outlined"
                    multiline
                    value={personalData.contact_address}
                    onChange={e => handlePersonalDataChange('contact_address', e.target.value)}
                    error={!!formErrors.contact_address}
                    onBlur={evt => handleErrors('contact_address', evt.target.value)}
                    helperText={formErrors.contact_address}
                    rows={3}
                    disabled={isSubmitting}
                    
                />
                </Box>

                <TextField
                    fullWidth
                    label="Permanent Address"
                    variant="outlined"
                    multiline
                    value={personalData.permanent_address}
                    onChange={e => handlePersonalDataChange('permanent_address', e.target.value)}
                    error = {!!formErrors.permanent_address}
                    onBlur= {evt => handleErrors('permanent_address', evt.target.value)}
                    helperText={formErrors.permanent_address}
                    rows={3}
                    disabled={isSameAddress || isSubmitting}
                    InputProps={{
                        endAdornment: (
                            <Box
                            position="absolute"
                            top={10} 
                            right={10} 
                            display="flex"
                            alignItems="center"
                            >
                            <Tooltip 
                                title="Same as contact address"
                                // placement="top"
                                slotProps={{
                                    tooltip: { 
                                        sx: { fontSize: '0.8rem', padding:'4px 8px', transform: 'translateY(-12px)' } 
                                    }, 
                                    arrow: { 
                                        sx: { transform: 'translateY(4px)'}}
                                }}
                             arrow>
                            <Checkbox
                                checked={isSameAddress}
                                onChange={handleCheckedBox}
                                disabled={isSubmitting}
                                size="small"
                            />
                        </Tooltip>
                            
                            </Box>
                        ),
                        }}
                />
        </Box>

        <Box sx={{mt: 8}}>
            <Typography variant="h4" component="h2" sx={{mb: 2}}>
                Educational Information
            </Typography>

            <Typography variant="h6" component="h3" sx={{mb: 4}}>
                Educational details such as the under graduation or post graduation degree information,which
                institute you have studied and the year of passing.
            </Typography>

            <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr"}, gap: 3, mb: 8 }}>
                    <TextField 
                        fullWidth 
                        label="Highest Educational Qualification"
                        placeholder='under graduate or post graduate'
                        value={personalData.qualification}
                        onChange={evt => handlePersonalDataChange('qualification', evt.target.value)}
                        error = {!!formErrors.qualification}
                        onBlur= {evt => handleErrors('qualification', evt.target.value)}
                        helperText={formErrors.qualification}
                        disabled={isSubmitting}
                    />

                    <TextField
                        fullWidth
                        label="Name of the Institution"
                        placeholder="Name of the Education Institution"
                        value={personalData.institution}
                        onChange={evt => handlePersonalDataChange('institution', evt.target.value)}
                        onBlur= {evt => handleErrors('institution', evt.target.value)}
                        error = {!!formErrors.institution}
                        helperText={formErrors.institution}
                        disabled={isSubmitting}
                    />

                    <TextField
                        fullWidth
                        type="number"
                        label="Year of passing"
                        placeholder='Eg., 2021'
                        value={personalData.passingYear}
                        onChange={evt => handlePersonalDataChange('passingYear', Number(evt.target.value))}
                        onBlur= {evt => handleErrors('passingYear', evt.target.value)}
                        error = {!!formErrors.passingYear}
                        helperText={formErrors.passingYear}
                        disabled={isSubmitting}
                    />

            </Box>

            <Typography variant="h4" component="h2" sx={{ mb: 4 }}>
                Work Experience
            </Typography>

            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'}, gap: 3, mb: 8}}>
            <FormControl fullWidth error={!!formErrors.yearsOfExperience} disabled={isSubmitting}>
                <InputLabel>Years of Experience</InputLabel>
                <Select 
                    label="Years of Experience"
                    value={personalData.yearsOfExperience}
                    onChange={evt => handlePersonalDataChange('yearsOfExperience', evt.target.value)}
                    onBlur={evt => handleErrors('yearsOfExperience', evt.target.value)}
                >
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value=">5">Above 5</MenuItem>
                </Select>
                <FormHelperText>{formErrors.yearsOfExperience}</FormHelperText>
            </FormControl>


                    <TextField 
                        fullWidth
                        label="Previous/Current Company"
                        variant="outlined"
                        value={personalData.company}
                        onChange={evt => handlePersonalDataChange('company', evt.target.value)}
                        onBlur= {evt => handleErrors('company', evt.target.value)}
                        error = {!!formErrors.company}
                        helperText={formErrors.company}
                        disabled={isSubmitting}
                    />

                   
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Joining Date"
                    value={personalData.joiningDate ? dayjs(personalData.joiningDate) : null}
                    onChange={(newValue) => handlePersonalDataChange("joiningDate", newValue ? newValue.format("YYYY-MM-DD") : "")}
                    format="YYYY-MM-DD" // Ensures consistency with input value
                    slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: "outlined",
                        error: !!formErrors.joiningDate,
                        helperText: formErrors.joiningDate,
                        onBlur: (evt) => handleErrors("joiningDate", evt.target.value),
                        disabled: isSubmitting,
                        sx: {
                        "& .MuiInputLabel-root": { transform: "translate(14px, -13px) scale(0.75)" },
                        },
                    },
                    }}
                />
                </LocalizationProvider> */}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Joining Date"
                    value={personalData.joiningDate ?  dayjs(personalData.joiningDate, "YYYY-MM-DD") : null}
                    onChange={(newValue) => {
                        if(newValue) {
                            const formattedDate = newValue.format("YYYY-MM-DD");
                            handlePersonalDataChange("joiningDate", formattedDate);
                        } else {
                            handlePersonalDataChange("joiningDate", "");
                        }}
                    }
                        
                    format="DD-MM-YYYY" // Ensures consistency with input value
                    slotProps={{
                    textField: {
                        fullWidth: true,
                        variant: "outlined",
                        error: !!formErrors.joiningDate,
                        helperText: formErrors.joiningDate,
                        onBlur: (evt) => handleErrors("joiningDate", evt.target.value),
                        disabled: isSubmitting,
                        sx: {
                        "& .MuiInputLabel-root": { transform: "translate(14px, -13px) scale(0.75)" },
                        },
                    },
                    }}
                />
            </LocalizationProvider>





                    <FormControl fullWidth error={!!formErrors.employmentStatus}  disabled={isSubmitting}>
                        <InputLabel>Current Employment Status</InputLabel>
                        <Select 
                            label="Current Employment Status"
                            value={personalData.employmentStatus}
                            onChange={evt => handlePersonalDataChange('employmentStatus', evt.target.value)}
                            onBlur = {evt => handleErrors('employmentStatus', evt.target.value)}
                        >
                            <MenuItem value="Working">Working</MenuItem>
                            <MenuItem value="Relieved">Relieved</MenuItem>
                           
                        </Select>
                        <FormHelperText>{formErrors.employmentStatus}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth error = {!!formErrors.lastSalary}  disabled={isSubmitting}>
                        <InputLabel>Salary Last Drawn (CTC in Lakhs)</InputLabel>
                        
                        <Select 
                            label="Salary Last Drawn (CTC in lakhs)"
                            value={personalData.lastSalary}
                            onChange={evt => handlePersonalDataChange('lastSalary', evt.target.value)}
                            onBlur={evt => handleErrors('lastSalary', evt.target.value)}
                        >
                            
                            <MenuItem value="2 to 3 Lakhs">2 - 3 Lakhs</MenuItem>
                            <MenuItem value="3 to 4 Lakhs">3 - 4 Lakhs</MenuItem>
                            <MenuItem value="4 to 5 Lakhs">4 - 5 Lakhs</MenuItem>
                            <MenuItem value="5 to 6 Lakhs">5 - 6 Lakhs</MenuItem>
                            <MenuItem value="6 to 7 Lakhs">6 - 7 Lakhs</MenuItem>
                            <MenuItem value="7 to 8 Lakhs">7 - 8 Lakhs</MenuItem>
                            <MenuItem value="8 to 9 Lakhs">8 - 9 Lakhs</MenuItem>
                            <MenuItem value="9 to 10 Lakhs">9 - 10 Lakhs</MenuItem>
                            <MenuItem value="10 to 11 Lakhs">10 - 11 Lakhs</MenuItem>
                            <MenuItem value="11 to 12 Lakhs">11 - 12 Lakhs</MenuItem>
                            <MenuItem value="12 to 13 Lakhs">12 - 13 Lakhs</MenuItem>
                            <MenuItem value="13 to 14 Lakhs">13 - 14 Lakhs</MenuItem>
                            <MenuItem value="14 to 15 Lakhs">14 - 15 Lakhs</MenuItem>
                            <MenuItem value="Above 15">Above 15</MenuItem>

                        </Select>

                        <FormHelperText>{formErrors.lastSalary}</FormHelperText>
                    </FormControl>
                </Box>

                <Typography variant="h4" component="h2" sx={{mb: 4}}>
                        Salary Expectations & Terms
                </Typography>

                <Box sx={{display: "grid", gridTemplateColumns: {xs: '1fr', sm: '1fr 1fr'}, gap: 3, mb: 8}}>
                        <TextField
                            fullWidth
                            label="Expected Salary"
                            variant="outlined"
                            multiline
                            value={personalData.expectedSalary}
                            onChange={e => handlePersonalDataChange('expectedSalary', e.target.value)}
                            error = {!!formErrors.expectedSalary}
                            onBlur= {evt => handleErrors('expectedSalary', evt.target.value)}
                            helperText={formErrors.expectedSalary}
                            rows={3}
                            disabled={isSubmitting}
                        />

                        <FormControl component="fieldset" fullWidth error={!!formErrors.suretyAgreement}  disabled={isSubmitting}>
                            <FormLabel component="legend">Willing to sign third party surety agreement for 2 Years?</FormLabel>
                            <RadioGroup 
                            row
                             name="suretyAgreement"
                             value={personalData.suretyAgreement === true ? "yes" : personalData.suretyAgreement === false? "no" : ''}
                             onChange={evt => handlePersonalDataChange('suretyAgreement', evt.target.value === "yes")}
                             onBlur={evt => handleErrors('suretyAgreement', evt.target.value === "yes")}
                             >
                            
                                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="no" control={<Radio />} label="No" />
                            </RadioGroup>
                            <FormHelperText>{formErrors.suretyAgreement}</FormHelperText>
                        </FormControl>

                        <TextField 
                            fullWidth label="Joining Time (in days)" 
                            type="number" 
                            variant="outlined" 
                            value={personalData.joiningDays}
                            onChange={evt => handlePersonalDataChange('joiningDays', Number(evt.target.value))}
                            onBlur={evt => handleErrors('joiningDays', evt.target.value)}
                            error = {!!formErrors.joiningDays}
                            disabled={isSubmitting}
                            helperText={formErrors.joiningDays}
                        />

                </Box>
    </Box>

   

            {/* Submit Button */}
            <Box sx={{ textAlign: 'center', mt: 4 }}>
                <Button
                type="submit"
                variant="contained" 
                size="large"
                sx={{ px: 4, py: 1 }}
                disabled={false}
               
                >
                Submit
                </Button>
            </Box>
                {isLoading && (
                     <Box
                       sx={{
                         position: 'absolute',
                         top: 0,
                         left: 0,
                         width: '100%',
                         height: '100%',
                         backgroundColor: 'rgba(255, 255, 255, 0.6)',
                         display: 'flex',
                         justifyContent: 'center',
                         alignItems: 'center',
                         zIndex: 1,
                       }}
                     >
                       <Loader />
                     </Box>
                   )}
            </form>
        </div>

        </Paper>

    )
}